import { PhitoObjectBase } from '../../services/phito-object';

export class Todo extends PhitoObjectBase {
    title: string;
    description: string;
    dueDate: Date;
    checked: boolean;
    isChecking: boolean;
}

export class TodoList extends PhitoObjectBase {
    listName: string;
    todos: Todo[];
}
